export const PASSWORD_RULES = [
  {
    id: 'minLength',
    label: 'At least 8 characters',
    test: v => /.{8,}/.test(v),
  },
  {
    id: 'uppercase',
    label: 'At least one uppercase letter (A–Z)',
    test: v => /[A-Z]/.test(v),
  },
  {
    id: 'lowercase',
    label: 'At least one lowercase letter (a–z)',
    test: v => /[a-z]/.test(v),
  },
  {
    id: 'number',
    label: 'At least one number (0–9)',
    test: v => /[0-9]/.test(v),
  },
  {
    id: 'special',
    label: 'At least one special character (!@#$%…)',
    test: v => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(v),
  },
]

export function isPasswordStrong(password) {
  return PASSWORD_RULES.every(rule => rule.test(password || ''))
}
